import listingImage1 from './images/featured_listing_1.jpg';
import listingImage2 from './images/featured_listing_2.jpg';
import listingImage3 from './images/featured_listing_3.jpg';
import avatarImage1 from './images/avatar_1.jpg';
import avatarImage2 from './images/avatar_2.jpg';
import avatarImage3 from './images/avatar_3.jpg';

export const linksProps = {
  listing1: {
    id: '60b608e6-e23d-41fd-bceb-bbc38841fefc',
    title: 'BELLISSIMA PISCINA CON PANORAMA SUL MUGELLO',
    price: '2000',
    image: listingImage1,
    provider: {
      avatar: avatarImage1,
      displayName: 'Lorella C',
      abbreviatedName: 'LC',
    },
  },
  listing2: {
    id: '608afecf-5177-4742-8784-56b43004dedc',
    title: 'Piscina Il Tramonto',
    price: '2000',
    image: listingImage2,
    provider: {
      avatar: avatarImage2,
      displayName: 'William Z',
      abbreviatedName: 'WZ',
    },
  },
  listing3: {
    id: '60ba2450-cfd6-495b-9d6b-beca65416ae9',
    title: 'Piscina scoperta e solarium nel cuore di Napoli',
    price: '1000',
    image: listingImage3,
    provider: {
      avatar: avatarImage3,
      displayName: 'Franco P',
      abbreviatedName: 'FP',
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/LandingPage/listingsConfig.js